import { Component, OnInit, Output, EventEmitter, OnDestroy } from "@angular/core";
import { PatientsService } from "../patients.service";
import { PregnancyService } from "../pregnancy.service";
import { ExamsService } from "../exams.service";
import { Patient } from "../patients/patient";
import { LoginService } from "../login.service";

import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { SignatureService } from "../signature.service";

@Component({
    selector: "app-examsbar",
    templateUrl: "./examsbar.component.html",
    styleUrls: ["./examsbar.component.scss"],
    standalone: false
})
export class ExamsbarComponent implements OnInit, OnDestroy {
  @Output() pageChange = new EventEmitter<string>();
  @Output() showPatDetails = new EventEmitter();
  currentPage = "Pregnancy";
  showPat: boolean = false;
  sub = new Subscription();
  isBookmark = false;

  pat: Patient;
  constructor(
    public patientsService: PatientsService,
    public examsService: ExamsService,
    public loginService: LoginService,
    public signatureService: SignatureService,
    private router: Router
  ) {}

  ngOnInit() {
    this.pat = this.patientsService.getPat();
    if (this.pat.ID == "default") this.currentPage = "Placenta";
    if (this.loginService.isCardio) {
      this.currentPage = "Introduction";
    }
  }

  setPage(page: string) {
    this.examsService.ShowSRs = false;
    this.currentPage = page;
    this.pageChange.emit(page);
  }

  showPatD() {
    this.showPatDetails.emit();
  }

  go(place: string) {
    this.router.navigateByUrl(place);
    this.examsService.exitExam();
  }

  bookmark() {
    console.log(this.examsService.examID);
    this.isBookmark = !this.isBookmark;
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  handleClose(place: string) {
    const examObject = this.examsService.examObject;
    const isDoctor = this.examsService.isDoctor();
    const isExamSigned = this.signatureService.isExamSigned(examObject);
    const isClosed = this.examsService.isClosed;

    if (isDoctor && !isExamSigned && !isClosed && this.pat?.ID != 'default') {
      this.signatureService.alertToSign$.next(true);
    } else {
      this.router.navigateByUrl(place);
      this.examsService.exitExam();
    }
  }
}
